import { MouseCatcher } from '@naker/services/Catchers/mouseCatcher';
import { GradientEnvironment } from '@naker/services/System/gradientEnvironment';
import { coreSystem } from './system';

import { Vector2 } from '@babylonjs/core/Maths/math'
import { ArcRotateCamera } from '@babylonjs/core/Cameras/ArcRotateCamera'
// import { MotionBlurPostProcess } from '@babylonjs/core/PostProcesses/MotionBlurPostProcess';
// import { ImageProcessingPostProcess } from '@babylonjs/core/PostProcesses/ImageProcessingPostProcess';
// import { FxaaPostProcess } from '@babylonjs/core/PostProcesses/FxaaPostProcess';

// import { StandardRenderingPipeline } from '@babylonjs/core/PostProcesses/RenderPipeline/Pipelines/StandardRenderingPipeline';
// import '@babylonjs/core/Rendering/depthRendererSceneComponent';
// import { DefaultRenderingPipeline } from '@babylonjs/core/PostProcesses/RenderPipeline/Pipelines/defaultRenderingPipeline';
// import { BlurPostProcess } from '@babylonjs/core/PostProcesses/blurPostProcess';
// import { DepthOfFieldEffect } from '@babylonjs/core/PostProcesses/depthOfFieldEffect';

export interface environmentInterface {
    gradient?: 'vertical' | 'horizontal' | 'radial';
    colorStart? : Array < number >;
    colorEnd? : Array < number >;
    sensitivity? : number;
    // blurStrenght?:number,
    // motionBlurStrenght?:number,
    // vignetteColor ? : Array < number > ,
}

export class Environment extends GradientEnvironment {

    system: coreSystem;
    camera: ArcRotateCamera;
    sensitivity: number;

    constructor(system: coreSystem, mouseCatcher: MouseCatcher, options: environmentInterface) {
        super(system);

        this.camera = this.system.camera;
        this.setEvents(mouseCatcher);
        this.setCameraRotation(Vector2.Zero());
        
        // Argument changes
        if (!options.gradient) options.gradient = 'vertical';
        this.setOptions(options);

        // var postProcess = new FxaaPostProcess("fxaa", 1.0, this.camera);
        // this.setDepthOfField();
        // this.setBlur();
        // this.setVignette();
    }

    setEvents(mouseCatcher: MouseCatcher) {
        mouseCatcher.addListener((mousepos: Vector2) => {
            if (this.sensitivity != 0) {
                let newrot = new Vector2(mousepos.y / 5, mousepos.x / 5);
                this.setCameraRotation(newrot);
            }
        });
    }

    setOptions(options: environmentInterface) {
        if (options.sensitivity !== undefined) this.setSensitivity(options.sensitivity);
        if (options.gradient !== undefined) this.setSkyGradient(options.gradient);
        if (options.colorStart !== undefined) this.setBackStart(options.colorStart);
        if (options.colorEnd !== undefined) this.setBackStop(options.colorEnd);
        // if (options.blurStrenght !== undefined) this.setBlurStrenght(options.blurStrenght);
        // if (options.motionBlurStrenght !== undefined) this.setMotionBlurStrenght(options.motionBlurStrenght);
        // this.setVignetteColor(options.vignetteColor);
        this.setCameraRotation(Vector2.Zero());
    }

    getOptions(): environmentInterface {
        let options: environmentInterface = {
            gradient: this.gradient,
            sensitivity: this.sensitivity,
            colorStart: this.colorStart,
            colorEnd: this.colorEnd,
        };
        return options;
    }

    setSensitivity(sensitivity: number) {
        this.sensitivity = sensitivity;
    }

    setCameraRotation(rot: Vector2) {
        let width = this.system.engine.getRenderWidth();
        let height = this.system.engine.getRenderHeight();
        let radiusSensitivity = 500000 / (Math.max(width, height));
        let radius = 30 + rot.x * -rot.y * this.sensitivity * radiusSensitivity;

        // Make sure the camera doesn't go outside sky sphere
        this.camera.radius = Math.min(Math.max(1, radius), this.skySize / 3);

        this.camera.alpha = 3 * rot.y * this.sensitivity - Math.PI / 2;
        this.camera.beta = 3 * rot.x * this.sensitivity + Math.PI / 2;
    }

    // motionBlur:MotionBlurPostProcess;
    // // blur:BlurPostProcess;
    // setBlur () {
    //   this.motionBlur = new MotionBlurPostProcess(
    //       "mb", // The name of the effect.
    //       this.system.scene, // The scene containing the objects to blur according to their velocity.
    //       10.0, // The required width/height ratio to downsize to before computing the render pass.
    //       this.camera // The camera to apply the render pass to.
    //   );
    //   this.motionBlur.motionStrength = 10;
    // //   this.blur = new BlurPostProcess("Horizontal blur", new Vector2(1.0, 0), 8, 0.25, this.camera);
    // }

    // setBlurStrenght (motionBlurStrenght:number) {
    //   if (motionBlurStrenght == 0) this.blur._options = 1;
    //   else this.blur._options = 0.25;
    //
    //   this.blurStrenght = motionBlurStrenght;
    //   this.blur.kernel = motionBlurStrenght;
    // }

    // setMotionBlurStrenght (motionBlurStrenght:number) {
    //   this.motionBlurStrenght = motionBlurStrenght;
    //   this.motionBlur.motionStrength = motionBlurStrenght;
    // }

    // imageProcessing:ImageProcessingPostProcess;
    // setVignette () {
    //     this.imageProcessing = new ImageProcessingPostProcess("processing", 1.0, this.camera);
    //     this.imageProcessing.vignetteWeight = 0;
    //     this.imageProcessing.vignetteStretch = 1;
    //     this.imageProcessing.vignetteEnabled = true;
    //     this.imageProcessing.vignetteBlendMode = ImageProcessingPostProcess.VIGNETTEMODE_OPAQUE;
    // }

    // setVignetteColor (color:Array<number>) {
    //     this.vignetteColor = color;
    //     if (color == undefined) return this.imageProcessing.vignetteWeight = 0;
    //     this.imageProcessing.vignetteWeight = color[3] * 10;
    //     this.imageProcessing.vignetteColor = Color4.FromInts(color[0],color[1],color[2], 1);
    // }

    // depthOfField: DepthOfFieldEffect;
    // setDepthOfField() {
    //     // this.depthOfField = new DepthOfFieldEffect(this.system.scene, null);
    //     // // this.depthOfField.focalLength = 1;
    //     // // this.depthOfField.focusDistance = oldDof.focusDistance;
    //     // // this.depthOfField.fStop = oldDof.fStop;
    //     // // this.depthOfField.lensSize = oldDof.lensSize;
    //     // const depthRenderer = this.system.scene.enableDepthRenderer(this.system.scene.activeCamera);
    //     // this.depthOfField.depthTexture = depthRenderer.getDepthMap();

    //     var pipeline = new DefaultRenderingPipeline("default", true, this.system.scene, [this.system.scene.activeCamera]);
    //     pipeline.imageProcessingEnabled = false;
    //     this.system.scene.imageProcessingConfiguration.isEnabled = false;
    //     // pipeline.depthOfFieldBlurLevel = DepthOfFieldEffectBlurLevel.Medium;
    //     pipeline.depthOfFieldEnabled = true;
    //     pipeline.depthOfField.focalLength = 180;
    //     pipeline.depthOfField.fStop = 3;
    //     pipeline.depthOfField.focusDistance = 2250;
    //     this.depthOfField = pipeline.depthOfField;
    //     console.log(pipeline.depthOfField);
    // }
}